import { Component, OnInit } from '@angular/core';
import { ScheduleService } from '../shared/schedule.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from '../shared/message.service';
import { NotificationService } from '../shared/notification.service';
import { PriceManagementFilterService } from '../price-management/price-management-filter.service';
import { Router } from '@angular/router';
import { PermissionsService } from '../shared/permissions.service';
import { AuthenticationService } from '../core/authentication/shared/authentication.service';
import * as moment from 'moment';
import 'moment-timezone';
import { ReportService } from '../shared/report.service';
import { StoreService } from '../shared/store.service';
import { AnnouncementService } from '../shared/announcement.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  schedule;
  weekEndingDateForPosExport;
  previewWindowCountdownTimer = 'calculating...';
  meatPreviewWindowCountdownTimer = 'calculating...';
  producePreviewWindowCountdownTimer = 'calculating...';
  storeItemPricingWindowCountdownTimer = 'calculating...';
  meatStoreItemPricingWindowCountdownTimer = 'calculating...';
  produceStoreItemPricingWindowCountdownTimer = 'calculating...';
  previewPricingWindowOpen: boolean = false;
  meatPreviewPricingWindowOpen: boolean = false;
  producePreviewPricingWindowOpen: boolean = false;
  storeItemPricingWindowOpen: boolean = false;
  meatStoreItemPricingWindowOpen: boolean = false;
  produceStoreItemPricingWindowOpen: boolean = false;
  previewTimer;
  meatPreviewTimer;
  producePreviewTimer;
  storeItemPricingTimer;
  meatStoreItemPricingTimer;
  produceStoreItemPricingTimer;
  nowCostChangesCount: string = '<i class="fas fa-sync fa-spin"></i>';
  firstTimeBuysCount: string = '<i class="fas fa-sync fa-spin"></i>';
  now: number = Date.now();
  nowCostChangesSubscription;
  firstTimeBuysSubscription;
  permissions: any = {};
  announcements = [];

  constructor(
    private _scheduleService: ScheduleService,
    private _announcementService: AnnouncementService,
    private _messageService: MessageService,
    private _notificationService: NotificationService,
    private _priceManagementFilterService: PriceManagementFilterService,
    private _permissionsService: PermissionsService,
    private _authenticationService: AuthenticationService,
    private _reportService: ReportService,
    private _storeService: StoreService,
    private _router: Router,
    ) { 
      this.permissions = this._permissionsService.getPermissions();
    }

  ngOnInit() {
    this.getActiveAnnouncements();
  }

  getActiveAnnouncements(){
    this._announcementService.getActiveAnnouncements()
      .subscribe(
        (data : any)=>{
          this.announcements = data;
          this.getSchedule();
        },
        (response : HttpErrorResponse)=>{
          this._messageService.onFailure('Failed to get announcements.', response);
        });
  }

  getSchedule() {
    this._scheduleService.getSchedule()
      .subscribe(
        (data : any)=>{
          this.schedule = data;
          this.getNowCostChangesCount();
          this.getFirstTimeBuysCount();
          this.getGroceryPreviewPricingWindowStatus();
        },
        (response : HttpErrorResponse)=>{
          this._messageService.onFailure('Failed to get schedule.', response);
        });
  }

  getNowCostChangesCount(){
    this.nowCostChangesSubscription = this._notificationService.getNowCostChangesCount()
      .subscribe(
        (data : any)=>{
          this.nowCostChangesCount = data.nowCostChangesCount;
        },
        (response : HttpErrorResponse)=>{
          this._messageService.onFailure('Failed to get now cost changes.', response);
        })
  }

  getFirstTimeBuysCount(){
    this.firstTimeBuysSubscription = this._notificationService.getFirstTimeBuysCount()
      .subscribe(
        (data : any)=>{
          this.firstTimeBuysCount = data.firstTimeBuysCount;
        },
        (response : HttpErrorResponse)=>{
          this._messageService.onFailure('Failed to get first time buys.', response);
        })
  }

  getGroceryPreviewPricingWindowStatus(){
    this._scheduleService.isScheduleWindowOpen('PreviewPricingWindow')
      .subscribe(
        (data : any)=>{
          this.previewPricingWindowOpen = data.value;
          //this.previewPricingWindowOpen ? this.startPreviewWindowCountDownTimer(this.schedule.previewPricingWindowCloses) : this.startPreviewWindowCountDownTimer(this.schedule.previewPricingWindowOpens);
          if (this.previewPricingWindowOpen){
            this.previewTimer = this.startCountdownTimer(this.schedule.previewPricingWindowCloses, val => { this.previewWindowCountdownTimer = val;})
          }
          else {
            this.previewTimer = this.startCountdownTimer(this.schedule.previewPricingWindowOpens, val => { this.previewWindowCountdownTimer = val;})
          }
          this.getMeatPreviewPricingWindowStatus();
        },
        (response : HttpErrorResponse)=>{
          this._messageService.onFailure('Failed to get grocery preview pricing window status.', response);
        });
  }

  getMeatPreviewPricingWindowStatus(){
    this._scheduleService.isScheduleWindowOpen('MeatPreviewPricingWindow')
      .subscribe(
        (data : any)=>{
          this.meatPreviewPricingWindowOpen = data.value;
          //this.meatPreviewPricingWindowOpen ? this.startMeatPreviewWindowCountDownTimer(this.schedule.meatPreviewPricingWindowCloses) : this.startMeatPreviewWindowCountDownTimer(this.schedule.meatPreviewPricingWindowOpens);
          if (this.meatPreviewPricingWindowOpen){
            this.meatPreviewTimer = this.startCountdownTimer(this.schedule.meatPreviewPricingWindowCloses, val => { this.meatPreviewWindowCountdownTimer = val;})
          }
          else {
            this.meatPreviewTimer = this.startCountdownTimer(this.schedule.meatPreviewPricingWindowOpens, val => { this.meatPreviewWindowCountdownTimer = val;})
          }
          this.getProducePreviewPricingWindowStatus();
        },
        (response : HttpErrorResponse)=>{
          this._messageService.onFailure('Failed to get meat preview pricing window status.', response);
        });
  }

  getProducePreviewPricingWindowStatus(){
    this._scheduleService.isScheduleWindowOpen('ProducePreviewPricingWindow')
      .subscribe(
        (data : any)=>{
          this.producePreviewPricingWindowOpen = data.value;
          //this.producePreviewPricingWindowOpen ? this.startProducePreviewWindowCountDownTimer(this.schedule.producePreviewPricingWindowCloses) : this.startProducePreviewWindowCountDownTimer(this.schedule.producePreviewPricingWindowOpens);
          if (this.producePreviewPricingWindowOpen){
            this.producePreviewTimer = this.startCountdownTimer(this.schedule.producePreviewPricingWindowCloses, val => { this.producePreviewWindowCountdownTimer = val;})
          }
          else {
            this.producePreviewTimer = this.startCountdownTimer(this.schedule.producePreviewPricingWindowOpens, val => { this.producePreviewWindowCountdownTimer = val;})
          }
          this.getStoreItemPriceChangesWindowStatus();
        },
        (response : HttpErrorResponse)=>{
          this._messageService.onFailure('Failed to get produce preview pricing window status.', response);
        });
  }

  getStoreItemPriceChangesWindowStatus(){
    this._scheduleService.isScheduleWindowOpen('StoreItemPriceChangesWindow')
      .subscribe(
        (data : any)=>{
          this.storeItemPricingWindowOpen = data.value;
          if (this.storeItemPricingWindowOpen){
            this.storeItemPricingTimer = this.startCountdownTimer(this.schedule.storeItemPriceChangesWindowCloses, val => { this.storeItemPricingWindowCountdownTimer = val;})
          }
          else {
            this.storeItemPricingTimer = this.startCountdownTimer(this.schedule.storeItemPriceChangesWindowOpens, val => { this.storeItemPricingWindowCountdownTimer = val;})
          }
          this.getMeatStoreItemPriceChangesWindowStatus();
        },
        (response : HttpErrorResponse)=>{
          this._messageService.onFailure('Failed to get store item price changes window status.', response);
        });
  }

  getMeatStoreItemPriceChangesWindowStatus(){
    this._scheduleService.isScheduleWindowOpen('MeatStoreItemPriceChangesWindow')
      .subscribe(
        (data : any)=>{
          this.meatStoreItemPricingWindowOpen = data.value;
          if (this.meatStoreItemPricingWindowOpen){
            this.meatStoreItemPricingTimer = this.startCountdownTimer(this.schedule.meatStoreItemPriceChangesWindowCloses, val => { this.meatStoreItemPricingWindowCountdownTimer = val;})
          }
          else {
            this.meatStoreItemPricingTimer = this.startCountdownTimer(this.schedule.meatStoreItemPriceChangesWindowOpens, val => { this.meatStoreItemPricingWindowCountdownTimer = val;})
          }
          this.getProduceStoreItemPriceChangesWindowStatus();
        },
        (response : HttpErrorResponse)=>{
          this._messageService.onFailure('Failed to get meat store item price changes window status.', response);
        });
  }

  getProduceStoreItemPriceChangesWindowStatus(){
    this._scheduleService.isScheduleWindowOpen('ProduceStoreItemPriceChangesWindow')
      .subscribe(
        (data : any)=>{
          this.produceStoreItemPricingWindowOpen = data.value;
          if (this.produceStoreItemPricingWindowOpen){
            this.produceStoreItemPricingTimer = this.startCountdownTimer(this.schedule.produceStoreItemPriceChangesWindowCloses, val => { this.produceStoreItemPricingWindowCountdownTimer = val;})
          }
          else {
            this.produceStoreItemPricingTimer = this.startCountdownTimer(this.schedule.produceStoreItemPriceChangesWindowOpens, val => { this.produceStoreItemPricingWindowCountdownTimer = val;})
          }
        },
        (response : HttpErrorResponse)=>{
          this._messageService.onFailure('Failed to get produce store item price changes window status.', response);
        });
  }

  startCountdownTimer(dt: string, onTick: (value: string) => void) {
    const end = moment.tz(dt, 'America/Chicago'); // fixed target time in Central
    const _second = 1000;

    const timer = setInterval(() => {
      const now = moment(); // current local moment (in UTC internally)
      const distance = end.diff(now);

      if (distance <= 0) {
        clearInterval(timer);
        onTick('Expired!');
        return;
      }

      const duration = moment.duration(distance);
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      const result = `${days} days ${hours} hrs ${minutes} mins ${seconds} secs`;
      onTick(result);
    }, _second);

    return timer;
  }

  goToPriceManagement(itemFilterName, tab, subtab){
    var tabFilterModel = {
      activeTab: tab,
      activeSubTab: subtab,
    }
    this._priceManagementFilterService.setTabModel(tabFilterModel);
    this._priceManagementFilterService.setNameOfItemFilterToApplyAfterLoadingItems(itemFilterName);
    this._router.navigate(['/price-management/']);
  }

  onExportClick(){
    var homeStoreId = this._authenticationService.getMyUser().homeStoreId;
    if (homeStoreId) {
      this._storeService.getStoreById(homeStoreId)
        .subscribe(
          (data : any) => {
            this.getWeekEndingDatesForPosExport(data);
          },
          (response : HttpErrorResponse)=>{
            this._messageService.onFailure('Failed to get store.', response);
          });
    }
    else {
      this._router.navigate(['/reports/cash-register-actual-file-report']);
    }
  }

  getWeekEndingDatesForPosExport(store) {
    this._reportService.getWeekEndingDatesForPosExport('Grocery')
      .subscribe(
        (data: any) => {
          this.weekEndingDateForPosExport = String(moment(data[0]).format("YYYY-MM-DD"))
          this.exportCashRegisterFile(store);
        },
        (response) => {
          this._messageService.onFailure('Failed to get Week Ending Date.', response);
        }
      )
  }

  exportCashRegisterFile(store){
    if (this.permissions.roleAllowsUserToExportCashRegisterFile) {
      this._reportService.delimitedPosExportByStoreIdDateAndFilter(store.storeId, this.weekEndingDateForPosExport, 'Grocery')
        .subscribe(
          (result: any) => {
            //console.log(result)
            //var url = URL.createObjectURL(new Blob([result.data]));
            var url = URL.createObjectURL(result.body);
            var a = document.createElement('a');
            a.href = url;
            //POS_Data_for_Store_006_with_Filter_None_Exported_2018-11-29_131944.csv
            var downloadDateTime = moment().format('YYYY-MM-DD_HHmmss');
            a.download = 'POS_Data_for_Store_' + this.pad(store.storeNumber, 3) + '_with_Filter_Grocery_Exported_' + downloadDateTime + '_Week_Ending_Date_' + this.weekEndingDateForPosExport + '.csv';
            //a.download = result.filename;
            a.target = '_blank';
            a.click();
          },
          (response) => {
            this._messageService.onFailure('Failed to get Cash Register File.', response);
          }
        )
    }
    else {
      this._messageService.alert('Your role does not have permission to export this file.');
    }
  }

  pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }

  ngOnDestroy(){
    if (this.previewTimer) clearInterval(this.previewTimer);
    if (this.meatPreviewTimer) clearInterval(this.meatPreviewTimer);
    if (this.producePreviewTimer) clearInterval(this.producePreviewTimer);
    if (this.storeItemPricingTimer) clearInterval(this.storeItemPricingTimer);
    if (this.meatStoreItemPricingTimer) clearInterval(this.meatStoreItemPricingTimer);
    if (this.produceStoreItemPricingTimer) clearInterval(this.produceStoreItemPricingTimer);

    // Guarded unsubscribe to avoid "cannot read properties of undefined (reading 'unsubscribe')" errors
    try {
      if (this.nowCostChangesSubscription && typeof this.nowCostChangesSubscription.unsubscribe === 'function') {
        this.nowCostChangesSubscription.unsubscribe();
        this.nowCostChangesSubscription = null;
      }
    } catch (e) {
      console.warn('Failed to unsubscribe nowCostChangesSubscription', e);
    }

    try {
      if (this.firstTimeBuysSubscription && typeof this.firstTimeBuysSubscription.unsubscribe === 'function') {
        this.firstTimeBuysSubscription.unsubscribe();
        this.firstTimeBuysSubscription = null;
      }
    } catch (e) {
      console.warn('Failed to unsubscribe firstTimeBuysSubscription', e);
    }
  }

}
